export class ApiClientError extends Error {
    constructor(message, options = {}) {
        super(message);
        this.name = 'ApiClientError';
        this.status = options.status ?? 500;
        this.code = options.code ?? 'request_failed';
        this.retryable = options.retryable ?? false;
        this.requestId = options.requestId ?? null;
    }
}

const parseApiError = (payload, response) => {
    const errorPayload = payload?.error;
    const message =
        errorPayload?.message ||
        payload?.message ||
        (typeof payload === 'string' ? payload : null) ||
        'Le service est temporairement indisponible.';

    return new ApiClientError(message, {
        status: response.status,
        code: errorPayload?.code,
        retryable: errorPayload?.retryable,
        requestId: errorPayload?.requestId || response.headers.get('x-request-id')
    });
};

export const fetchJson = async (input, init) => {
    const response = await fetch(input, init);
    const contentType = response.headers.get('content-type') || '';
    const isJson = contentType.includes('application/json');
    const payload = isJson ? await response.json().catch(() => null) : await response.text().catch(() => null);

    if (!response.ok) {
        throw parseApiError(payload, response);
    }

    return payload;
};

export const getUserFacingError = (error, fallback = 'Une erreur est survenue.') => {
    if (!error) return fallback;
    if (typeof error === 'string') return error;
    if (error instanceof ApiClientError) return error.message || fallback;
    if (typeof error.message === 'string' && error.message.trim()) return error.message;
    return fallback;
};
